const API_URL = '/user'

const USER_INFO_MAX_AGE_MS = 1000 * 60 * 15 // 15 minutes

export const state = () => ({
  users: [],
  roles: [],
  branches: [],
  user_info: null,
  user_info_fetched_at: null,
  permissions: null,
})

export const getters = {
  getAll: state => state.users,
  get: state => user_id => state.users.find(user => user.id === parseInt(user_id)),
  getRoles: state => state.roles,
  getBranches: state => state.branches,
  getBranch: state => branch_id => state.branches?.find(branch => branch.wasteCompanyBranchId === parseInt(branch_id)),
  getUserInfo: state => state.user_info,
  isUserInfoStale: state => {
    if (!state.user_info_fetched_at) return true
    return Date.now() - state.user_info_fetched_at > USER_INFO_MAX_AGE_MS
  },
  getUserPermissions: state => state.permissions,
}

export const mutations = {
  PUSH_OR_REPLACE_USER(state, new_user) {
    let user_index = state.users.findIndex(user => user.id === parseInt(new_user.id))

    if (user_index >= 0) {
      state.users.splice(user_index, 1, new_user)
    } else {
      state.users.push(new_user)
    }
  },
  SET_ROLES(state, roles) {
    state.roles = roles
  },
  SET_BRANCHES(state, branches) {
    state.branches = branches
  },
  SET_USER_INFO(state, userInfo) {
    state.user_info = userInfo
    state.user_info_fetched_at = Date.now()
  },
  SET_USER_PERMISSIONS(state, permissions) {
    state.permissions = permissions
  },
}

export const actions = {
  async fetch({ commit }, user_id) {
    let { data: user } = await useApi('/waste-company-users/' + user_id)

    commit('PUSH_OR_REPLACE_USER', user.value)

    return user.value
  },
  async update({ commit }, { user, user_id }) {
    await useApi('/waste-company-users/' + user_id, { method: 'put', body: user })

    commit('PUSH_OR_REPLACE_USER', user)

    return user
  },
  async deactivate({ commit }, { user, user_id }) {
    await useApi('/waste-company-users/' + user_id, { method: 'patch', body: user })

    commit('PUSH_OR_REPLACE_USER', user)

    return user
  },
  async fetchAllRoles({ commit }, params) {
    let { data: roles } = await useApi(API_URL + '/roles', { query: params })

    commit('SET_ROLES', roles.value.items)

    return roles.value.items
  },
  async fetchAllCompanyBranches({ commit }) {
    let { data: branches, error } = await useApi(API_URL + '/user-info/all-branches')

    if (error.value) {
      return []
    }

    commit('SET_BRANCHES', branches.value?.items)

    return branches.value.items
  },
  async fetchUserInfo({ commit }) {
    let { data: userInfo } = await useApi(API_URL + '/user-info')

    commit('SET_USER_INFO', userInfo.value)

    return userInfo.value
  },

  async fetchUserPermissions({ commit }) {
    let { data: userPermissions } = await useApi(API_URL + '/user-info/permissions')
    userPermissions = userPermissions.value?.map(permission => permission.value) || []

    commit('SET_USER_PERMISSIONS', userPermissions)

    return userPermissions
  },

  async fetchUniqueUserName({ commit }, { firstName, lastName }) {
    let { data } = await useApi(API_URL + '/user-info/unique-user-name', {
      params: {
        FirstName: firstName,
        LastName: lastName,
      },
    })
    return data.value
  },
  async resendRegistrationEmail({ commit }, userId) {
    let { data } = await useApi(`/waste-company-users/${userId}/resend-registration-email`, { method: 'patch' })
    return data.value
  },
  async fetchUserProfile() {
    let { data } = await useApi(`${API_URL}/profile`)
    return data.value
  },
  async updateUserProfile({ commit }, userProfile) {
    let { data } = await useApi(`${API_URL}/profile`, { method: 'put', body: userProfile })
    return data.value
  },
}
